import moment from 'moment'
import 'moment/locale/en-gb'
import 'moment/locale/de'
import 'moment/locale/es'
import 'moment/locale/fr'
import 'moment/locale/pt-br'
import 'moment/locale/pt'

export function I18N_setLocale(languageCode: string) {
    switch (languageCode) {
        case 'en-GB':
            return moment.locale('en-gb')
        case 'de-DE':
            return moment.locale('de')
        case 'es-ES':
            return moment.locale('es')
        case 'fr-FR':
            return moment.locale('fr')
        case 'pt-BR':
            return moment.locale('pt-br')
        case 'pt-PT':
            return moment.locale('pt')
        default:
            return moment.locale('en-gb')
    }
}
